"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[930],{

/***/ 13930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _components_ThemeMenu_ThemeMenu__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34824);
/* harmony import */ var _shared_components_DropDown_DropDown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68551);
/* harmony import */ var _shared_components_Button_ThemeButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33499);
/* harmony import */ var _shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93752);
/* harmony import */ var _contexts_pageProps__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2978);
/* harmony import */ var _hooks_useTheme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88130);








var ButtonTheme = function ButtonTheme(_ref) {
  var className = _ref.className,
      classNameButton = _ref.classNameButton,
      onClick = _ref.onClick;

  var _usePagePropsContext = (0,_contexts_pageProps__WEBPACK_IMPORTED_MODULE_5__/* .usePagePropsContext */ .b)(),
      isLanding = _usePagePropsContext.isLanding,
      landingBookViewConfig = _usePagePropsContext.landingBookViewConfig;

  var _useTheme = (0,_hooks_useTheme__WEBPACK_IMPORTED_MODULE_6__/* .useTheme */ .Fg)(),
      activeTheme = _useTheme.activeTheme,
      updateTheme = _useTheme.updateTheme;

  var toggleLightDarkTheme = function toggleLightDarkTheme() {
    var idThemeDefault = landingBookViewConfig === null || landingBookViewConfig === void 0 ? void 0 : landingBookViewConfig.defaultTheme;
    var isThemeDefaultDark = (0,_shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_4__/* .isDarkTheme */ .$o)(idThemeDefault);
    var idThemeLight, idThemeDark;

    if (isThemeDefaultDark) {
      idThemeLight = _shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_4__/* .MapIdThemeDarkToIdThemeLight */ .vr[idThemeDefault];
      idThemeDark = idThemeDefault;
    } else {
      idThemeLight = idThemeDefault;
      idThemeDark = _shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_4__/* .MapIdThemeLightToIdThemeDark */ .el[idThemeDefault];
    }

    var idThemeNew = activeTheme === idThemeLight ? idThemeDark : idThemeLight;
    updateTheme(idThemeNew);
  };

  var renderBtn = function renderBtn(active, openDD) {
    var handleClick = function handleClick(e) {
      if (onClick) {
        onClick(e);
      }

      if (isLanding) {
        toggleLightDarkTheme();
      } else {
        if (openDD) {
          openDD(e);
        }
      }
    };

    var isDark = (0,_shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_4__/* .isDarkTheme */ .$o)(activeTheme);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_Button_ThemeButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      isLightDarkModesOnly: true,
      active: active,
      className: classNameButton,
      isDarkTheme: isDark,
      onClick: handleClick
    });
  };

  if (isLanding) {
    return renderBtn();
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_DropDown_DropDown__WEBPACK_IMPORTED_MODULE_2__["default"], {
    className: className,
    toggleOnClickButton: true,
    button: function button(_ref2) {
      var show = _ref2.show,
          onClick = _ref2.onClick;
      return renderBtn(show, onClick);
    },
    popupProps: {
      hideOnScroll: false,
      // So the user will see what colors of a new chosen theme.
      backdropProps: {
        style: {
          backgroundColor: "transparent"
        }
      } // ========================================================

    },
    body: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_ThemeMenu_ThemeMenu__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ButtonTheme);

/***/ })

}]);